import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiPlus, FiMinus } = FiIcons

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const faqs = [
    {
      question: "How realistic are the AI-generated signatures?",
      answer: "Our AI creates highly realistic signatures with natural pen-stroke variations, pressure changes, and organic letterforms that mimic real handwriting. Each signature includes authentic details like ink pooling and dynamic tapering."
    },
    {
      question: "What formats do I get?",
      answer: "You receive your signature in three formats: high-resolution JPG for general use, transparent PNG for overlays, and scalable SVG for professional applications and large-scale printing."
    },
    {
      question: "Can I use these signatures commercially?",
      answer: "Yes! All signatures come with full commercial usage rights. You can use them for business cards, letterheads, contracts, and any professional or personal applications."
    },
    {
      question: "Do I need to create an account?",
      answer: "No account required! Simply enter your name, choose a style, and download your signature immediately. We believe in keeping things simple and fast."
    },
    {
      question: "How long does the generation process take?",
      answer: "The entire process takes about 30-60 seconds. This includes generating 3 variations, processing your selection, upscaling, and creating all format versions."
    },
    {
      question: "What if I don't like any of the 3 generated options?",
      answer: "You can generate a new set of 3 signature variations before making any payment. Once you find a signature you like, you can purchase and download the high-resolution files immediately."
    }
  ]

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index)
  }

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our signature generator
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900">{faq.question}</span>
                <SafeIcon 
                  icon={openIndex === index ? FiMinus : FiPlus} 
                  className="text-primary-600 flex-shrink-0"
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: 'auto' }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-4 text-gray-600">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ